<template>
    <div class="mqjc-dialog">
        <el-dialog :visible.sync="open" width="1771px" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="box" v-if="type == '园区监控'">
                <!-- 左侧 -->
                <div class="left">
                    <div class="deviceType" @click="handleClick('qiu')">
                        <div>
                            球机监控设备：<span>{{ QiujList.length }}台</span>
                        </div>
                        <i class="el-icon-caret-bottom" v-if="isShowQiujList"></i>
                        <i class="el-icon-caret-top" v-else></i>
                    </div>
                    <div class="list" ref="qiuList" :class="{active : isShowQiujList}">
                        <div class="list_item" v-for="(item,index) in QiujList" :key="index" @click="handleSelectDevice(item)">
                            <div class="list-item-head">
                                <div>
                                    <i class="el-icon-caret-right"></i>
                                    <!-- 球机设备{{ index+1 }} -->
                                    {{ item.name || ''}}
                                </div>
                                <i class="el-icon-rank"></i>
                            </div>
                            <div class="list-item-body">
                                <img :src="require(`../../../assets/images/jiankongImg/${item.id}.jpg`)" alt="">
                            </div>
                            <div class="list-item-footer">
                                <i class="el-icon-location"></i>
                                {{ item.address || '' }}
                            </div>
                        </div>
                    </div>
                    <div class="deviceType deviceType2" @click="handleClick('qiang')">
                        <div>
                            枪机监控设备：<span>{{QiangjList.length}}台</span>
                        </div>
                        <i class="el-icon-caret-bottom" v-if="isShowQiangjList"></i>
                        <i class="el-icon-caret-top" v-else></i>
                    </div>
                    <div class="list" ref="qiangList" :class="{active : isShowQiangjList}">
                        <div class="list_item" v-for="(item,index) in QiangjList" :key="index" @click="handleSelectDevice(item)">
                            <div class="list-item-head">
                                <div>
                                    <i class="el-icon-caret-right"></i>
                                    <!-- 球机设备{{ index+1 }} -->
                                    {{ item.name || ''}}
                                </div>
                                <i class="el-icon-rank"></i>
                            </div>
                            <div class="list-item-body">
                                <img :src="require(`../../../assets/images/jiankongImg/${item.id}.jpg`)" alt="">
                            </div>
                            <div class="list-item-footer">
                                <i class="el-icon-location"></i>
                                <!-- 成都市蒲江成佳茶园二号田 -->
                                {{ item.address || '' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧 -->
                <div class="right">
                    <!-- 视频 -->
                    <div class="video-box">
                        <span>{{info.name || ''}}</span>
                        <EZUIKitVideo 
                            :url="url" 
                            video-id="video-container-dialog"
                            :token="token"
                            :videoWidth="954" 
                            :videoHeight="750"
                        />
                    </div>
                    <div class="info-operate">
                        <!-- 基本信息 -->
                        <div class="basic-info">
                            <div class="name">
                                <img src="@/assets/images/seedlingMonitoring/icon.png" alt="">
                                <span>基本信息</span>
                            </div>
                            <!-- <div class="info-item">
                                <span class="info-item-label">设备类型：</span>
                                <span class="info-item-value">{{ info.productId == '65'? '球机' : '枪机' }}</span>
                            </div> -->
                             <div class="info-item">
                                <span class="info-item-label">设备状态：</span>
                                <span class="info-item-value">{{ formatStatus(info.state) }}</span>
                            </div>
                             <div class="info-item">
                                <span class="info-item-label">设备地址：</span>
                                <span class="info-item-value">{{ info.address }}</span>
                            </div>
                        </div>

                        <!-- 云台控制区 -->
                        <div class="control-zone" v-if="false"> 
                             <div class="name">
                                <img src="@/assets/images/seedlingMonitoring/icon.png" alt="">
                                <span>云台控制区</span>
                            </div>

                            <div class="operate">
                                <div class="distance">
                                    <div @mousedown="optClound(8)" @mouseup="endOptClound(8)">
                                        <span class="img1"></span>
                                        <span class="text">拉近</span>
                                    </div>
                                    <div @mousedown="optClound(9)" @mouseup="endOptClound(9)">
                                        <span class="img2"></span>
                                        <span class="text">拉远</span>
                                    </div>
                                </div>

                                <div class="direction-btn">
                                    <span @mousedown="optClound(4)" @mouseup="endOptClound(4)" class="zuoshang"></span>
                                    <span @mousedown="optClound(0)" @mouseup="endOptClound(0)" class="shang"></span>
                                    <span @mousedown="optClound(6)" @mouseup="endOptClound(6)" class="youshang"></span>
                                    <span @mousedown="optClound(2)" @mouseup="endOptClound(2)" class="zuo"></span>
                                    <div @mousedown="optClound('中间')" @mouseup="endOptClound('中间')" class="center"></div>
                                    <span @mousedown="optClound(3)" @mouseup="endOptClound(3)" class="you"></span>
                                    <span @mousedown="optClound(5)" @mouseup="endOptClound(5)" class="zuoxia"></span>
                                    <span @mousedown="optClound(1)" @mouseup="endOptClound(1)" class="xia"></span>
                                    <span @mousedown="optClound(7)" @mouseup="endOptClound(7)" class="youxia"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </el-dialog> 
    </div>
</template>
<script>
import {liveAddress} from "@/api/lsyn2"
import {equipList} from "@/api/lsyn2.js"
import EZUIKitVideo from '@/components/EZUIKitVideo.vue'
import {formatStatus} from "@/utils/tool"
export default {
    name: '',
    props:['mqjcDialog_show','type'],
    components:{
        EZUIKitVideo
    },
    data () {
        return {
            formatStatus,
            open:false,
            monitorList:[],
            curIdx:0,
            isShowQiujList:true,
            isShowQiangjList:true,
            QiangjList:[],
            QiujList:[],
            url:'',
            token:'',
            info:{},
        }
    },
    watch:{
        mqjcDialog_show(newValue){
            // console.log("newValue %%%%",newValue);
            this.open = newValue
            if(newValue){
                this.getEquipList()
            }
            // 关闭弹窗时关闭直播
            if(!newValue && this.type != '园区风采'){
                console.log("this.type ",this.type );
                // this.$refs.videoPlayer.player.pause()
            }
        },
    },
    created () {
    },
    mounted () {
        
    },
    methods: {
        getEquipList(){
            let para = {
                pageNum:1,
                pageSize:50,
                customerId:1357,
            }
            equipList(para).then(res=>{
                // console.log("res 获取设备列表",res);
                if(res.code == 200){
                    // this.QiujList = res.data.filter(val => val.productName == '海康-萤石云监控' || val.productName == '海康-萤石云苗情监控')
                    // this.QiangjList = res.data.filter(val => val.productName == '萤石云枪机')
                    // if(this.QiujList.length > 0){
                    //     this.info = this.QiujList[0]
                    //     if(this.mqjcDialog_show){
                    //         this.getliveAddress(this.QiujList[0].id)
                    //     }
                    // }
                }
            })
            
        },
        handleClick(type){
            if(type == 'qiu'){
                this.isShowQiangjList = true
                this.isShowQiujList = !this.isShowQiujList
                if(!this.isShowQiujList){
                    this.$refs.qiuList.scrollTop = 0
                }
            }else {
                this.isShowQiujList = true
                this.isShowQiangjList = !this.isShowQiangjList
                if(!this.isShowQiangjList){
                    this.$refs.qiangList.scrollTop = 0
                }
            }
        },
        handleSelectDevice(item){
            this.info = item
            this.getliveAddress(item.id)
        },
        getliveAddress(deviceId){
            liveAddress({deviceId:deviceId}).then(res=>{
                console.log("res 播放地址",res);
                if(res.code == 200){
                    if(res.data.url){
                        this.url = res.data.url 
                    }else{
                        this.msgError('设备离线，请检查设备')
                    }
                }
            })
        },
        optClound(code){    
            console.log("按下"+code);
            let para = {
                channelNo:"1",
                deviceSerial:this.monitorList[this.curIdx].deviceNo, 
                direction:code,
                speed:1
            }
            startPtz(para).then(res=>{
                console.log("res",res);
            })
        },
        endOptClound(code){
            console.log("抬起"+code);
            console.log("按下"+code);
            let para = {
                channelNo:"1",
                deviceSerial:this.monitorList[this.curIdx].deviceNo, 
                direction:code,
                speed:1
            }
            stopPtz(para).then(res=>{
                console.log("res",res);
            })
        },
    },
}
</script>
<style lang="less">
.mqjc-dialog{
    .el-dialog{
        margin-top: 8vh !important;
        background: transparent;
        box-shadow: unset;
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 0;
        }
    }
    .box{
        display: flex;
        position: relative;
        .left{
            width: 393px;
            height: 856px;
            background: url("~@/assets/images/seedlingMonitoring/dialog_left_bg.png");
            background-size: 100% 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .deviceType{
                background: rgba(43, 118, 130, 1);
                height: 56px;
                color: #fff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 25px 0 20px;
                >div{
                    font-size: 28px;
                    span{
                        color: rgba(250, 140, 67, 1);
                        margin-left: 12px;
                    }
                }
                i{
                    font-size: 22px;
                }
            }
            .deviceType2{
                margin-top: 12px;
            }
            .list{
                flex: 1;
                padding: 0 12px;
                transition: all 1s;
                overflow: auto;
                &::-webkit-scrollbar {
                    width: 0px;
                }
                &.active{
                    transition: all 1s;
                    flex: 0;
                }
                .list_item{
                    height: 280px; 
                    background: rgba(62, 84, 99, 0.36);
                    // border: 1px solid #fff;
                    cursor: pointer;
                    margin-top: 12px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .list-item-head{
                        height: 32px;
                        line-height: 32px;
                        background: rgba(136, 180, 209, 0.16);
                        color: rgba(255, 255, 255, .8);
                        display: flex;
                        justify-content: space-between;
                        padding: 0 25px 0 10px;
                        >div{
                            font-size: 16px;
                            i{
                                color: rgba(255, 141, 3, 1);
                            }
                        }
                        .el-icon-rank{
                            color: rgba(70, 188, 212, 1);
                            transform: rotate(135deg); 
                            margin-top: -26px;
                            font-size: 22px;
                        }
                    }
                    .list-item-body{
                        flex: 1;
                        padding: 0 12px;
                        overflow: hidden;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .list-item-footer{
                        height: 32px;
                        line-height: 32px;
                        background: rgba(136, 180, 209, 0.16);
                        font-size: 12px;
                        color: rgba(255, 255, 255, .8);
                        padding: 0 12px;
                    }
                }
                .active{
                    background: url("~@/assets/images/seedlingMonitoring/jk_list_active.png");
                    background-size: 100% 100%;
                    // background: linear-gradient(90deg, rgba(36, 132, 158, 0) 0%, rgba(43, 161, 194, 0.45) 49.31%, rgba(36, 132, 158, 0) 100%);
                    // border: 1px solid rgba(255, 255, 255, 0.4);
                }
            }

        }
        >.right{
            margin-left: 16px;
            width: 1378px;
            height: 856px;
            background: url("~@/assets/images/seedlingMonitoring/dialog_right_bg.png");
            background-size: 100% 100%;
            padding: 24px 27px 32px 36px;
            box-sizing: border-box;
            display: flex;
            .video-box{
                span{
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 40px;
                    color: rgba(255, 255, 255, 1);
                }
                // .video-play{
                //     width: 954px;
                //     height: 654px;
                //     margin-top: 26px;
                //     // background: url("~@/assets/images/test.jpg");
                //     // background-size: 100% 100%;
                //     // background-repeat: no-repeat;
                //     >div{
                //         width: 100%;
                //         height: 100% !important;
                //         padding-top: 0;
                //     }
                //     video{
                //         width: 100% !important;
                //         height: 100% !important;
                //         // height: calc(100vh - 95px) !important;
                //         object-fit:fill;  //消除留白
                //     }
                //     >div{
                //         .vjs-big-play-button{
                //             top: 50%;
                //             left: 50%;
                //             transform: translateY(-50%) translateX(-50%);
                //         } 
                //         >video{
                //             height: 100%;
                //         }
                //     }
                //     .vjs-button > .vjs-icon-placeholder:before{
                //         font-size: 0.6em;
                //     }
                // }
            }
            .info-operate{
                margin-top: 66px;
                margin-left: 33px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .basic-info{
                    .name{
                        display: flex;
                        align-items: center;
                        span{
                            margin-left: 5px;
                            font-size: 20px;
                            font-weight: 700;
                            line-height: 28px;
                            color: rgba(255, 255, 255, 0.8);
                        }      
                    }
                    .info-item{
                        margin-top: 12px;
                        font-size: 18px;
                        .info-item-label{
                            color: rgba(167, 186, 194, 0.6);
                        }
                        .info-item-value{
                            color: rgba(255, 255, 255, 0.8);
                        }
                    }
                }
            }

            // 云台控制区
            .control-zone{
                .name{
                    display: flex;
                    align-items: center;
                    span{
                        margin-left: 5px;
                        font-size: 20px;
                        font-weight: 700;
                        line-height: 28px;
                        color: rgba(255, 255, 255, 0.8);
                    }      
                }
                .operate{
                    margin-top: 16px;
                    width: 328px;
                    height: 382px;
                    background: rgba(10, 39, 51, 0.44);
                    padding: 22px;
                    box-sizing: border-box;
                    // 拉近拉远
                    .distance{
                        display: flex;
                        justify-content: space-between;
                        div{
                            width: 130px;
                            height: 42px;
                            background: rgba(20, 107, 107, 0.4);
                            border: 1px solid rgba(55, 228, 237, 0.4); 
                            font-size: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                            &:hover{
                                background: rgba(25, 129, 140, 1);
                                border: 1px solid rgba(29, 242, 232, 1);
                                .img1{
                                    background: url("~@/assets/images/seedlingMonitoring/lajin_active.png");
                                }
                                .img2{
                                    background: url("~@/assets/images/seedlingMonitoring/layuan_active.png");
                                }
                                .text{
                                    text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.5);
                                    color: rgba(247, 252, 255, 1);
                                }  
                            }
                            .img1{
                                width: 18px;
                                height: 18px;
                                background: url("~@/assets/images/seedlingMonitoring/lajin.png");
                                background-size: 100% 100%;
                            }
                            .img2{
                                width: 18px;
                                height: 18px;
                                background: url("~@/assets/images/seedlingMonitoring/layuan.png");
                                background-size: 100% 100%;
                            }
                            .text{
                                margin-left: 7px;
                                color: rgba(149, 191, 222, 1);
                            }
                        }
                    }

                    // 方向按钮
                    .direction-btn{
                        width: 100%;
                        height: 285px;
                        margin-top: 12px;
                        position: relative;
                        span{
                            width: 94px;
                            height: 94px;
                            display: block;
                        }
                        .zuoshang{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/zuoshang.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 0;
                            left: 0;
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/zuoshang_active.png");
                                background-size: 100% 100%;
                            }
                        }
                        .shang{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/shang.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 0;
                            left: 94px;
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/shang_active.png");
                                background-size: 100% 100%;
                            }
                        }
                        .youshang{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/youshang.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 0;
                            left: 188px;
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/youshang_active.png");
                                background-size: 100% 100%;
                            }
                        }
                        .zuo{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/zuo.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 94px;
                            left: 0; 
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/zuo_active.png");
                                background-size: 100% 100%;
                            }
                        }
                        .center{
                            width: 166px;
                            height: 166px;
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/center.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 59px;
                            left: 59px; 
                            z-index: 1;
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/center_active.png");
                                background-size: 100% 100%;
                            }
                        }
                        .you{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/you.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 94px;
                            left: 188px;
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/you_active.png");
                                background-size: 100% 100%;
                            } 
                        }
                        .zuoxia{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/zuoxia.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 188px;
                            left: 0; 
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/zuoxia_active.png");
                                background-size: 100% 100%;
                            } 
                        }
                        .xia{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/xia.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 188px;
                            left: 94px;
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/xia_active.png");
                                background-size: 100% 100%;
                            }  
                        }
                        .youxia{
                            background: url("~@/assets/images/seedlingMonitoring/yingshiyun/youxia.png");
                            background-size: 100% 100%;
                            cursor: pointer;
                            position: absolute;
                            top: 188px;
                            left: 188px; 
                            &:hover{
                                background: url("~@/assets/images/seedlingMonitoring/yingshiyun/youxia_active.png");
                                background-size: 100% 100%;
                            }  
                        }
                    }
                }
            }          
        }
    }
}
</style>
